import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../shared/shared.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { DocumentUploadService } from './document-upload.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { environment } from '../../../environments/environment';
@Component({
    selector: 'app-document-upload',
    templateUrl: './document-upload.component.html',
    styleUrls: ['./document-upload.component.scss'],
    standalone: false
})
export class DocumentUploadComponent implements OnInit {
  documentUploadForm: FormGroup;
  isLoading: Subject<boolean> = new Subject<boolean>();
  categoryList: any = [];
  modelList: any = [];
  variantList: any = [];
  modelListAll: any = [];
  fileTypes: any = [];
  variantListAll: any = [];
  uploadedFiles: File[] = [];
  displayedColumns: string[] = ['SNo', 'product_category', 'product_model', 'documents', 'status', 'action'];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  bucketurl = environment.bucketUrl;

  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  constructor(private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private documentService: DocumentUploadService) {
    this.documentUploadForm = this.fb.group({
      model: ['', Validators.required],
      category: ['', Validators.required],
      type: ['', Validators.required],
      link: ['', [Validators.required]]
      // , Validators.pattern(/^(https?:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/)
    });
  }

  public submitted: boolean = false;
  public isCreate: boolean = false;
  public isEdit: boolean = false;
  ngOnInit() {
    if (sessionStorage.getItem('masters')) {
      const masters = JSON.parse(sessionStorage.getItem('masters') || '{}');
      if (masters) {
        this.categoryList = masters?.documentProductCategory ? masters?.documentProductCategory : [];
        this.modelListAll = masters?.productModel ? masters?.productModel : [];
        this.fileTypes = masters?.documentFileType ? masters?.documentFileType : [];
      }
    }
    this.getList();
  }

  get f() { return this.documentUploadForm.controls; }

  add() {
    this.isCreate = true;
    this.alreadyUploadedFiles = []
  }

  selectedObject: any = {}
  alreadyUploadedFiles: any = [];
  editData(object: any) {
    this.onCategoryChange(object.product_category_id);
    this.isEdit = true;
    this.selectedObject = object;
    this.isLink = false;
    this.isDocument = false;

    // if (object.file_type == 'link') {
    //   this.isLink = true;
    //   this.isDocument = false;
    //   this.documentUploadForm.controls['link'].enable()
    //   this.documentUploadForm.patchValue({
    //    link: object.document_link
    //   });
    // } else {
    //   this.isLink = false;
    //   this.isDocument = true;
    //   this.documentUploadForm.controls['link'].disable()
    // }
    this.alreadyUploadedFiles = object.product_document_data;
    console.log("alreadyUploadedFiles:", this.alreadyUploadedFiles)
    this.documentUploadForm.patchValue({
      model: object.product_model_id,
      category: object.product_category_id,
      type: '',
    });
  }

  linkName: any = ''
  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.getList();
  }

  create() {
    this.submitted = true;
    if (!this.documentUploadForm.valid) {
      return;
    } else {
      if (this.isLink) {
        if (!this.linkName) {
          this.toastr.error('Please enter a name for link!');
          return;
        } else {
          this.isLoading = new BehaviorSubject<boolean>(true);
          const requestData = this.documentUploadForm.value;
          const formData: any = new FormData();
          formData.append('product_category', requestData.category);
          formData.append('product_model', requestData.model);
          formData.append('file_type', requestData.type);
          formData.append('document_link', requestData.link ? requestData.link : '');
          formData.append('document[]', '');
          formData.append('document_name', this.linkName);
          this.documentService.uploadDocument(formData).subscribe((response: any) => {
            let responseData = response.body;
            if (responseData.responseCode == 200) {
              this.isLoading = new BehaviorSubject<boolean>(false);
              this.toastr.success('The document uploaded successfully')
              this.back()
            } else {
              this.isLoading = new BehaviorSubject<boolean>(false);
              this.toastr.error(responseData.responseMessage)
            }
          }, (err) => {
            this.isLoading = new BehaviorSubject<boolean>(false);
            this.toastr.error(err)
          });
        }
      } else {
        if (this.uploadedFiles.length > 0) {
          this.isLoading = new BehaviorSubject<boolean>(true);
          const requestData = this.documentUploadForm.value;
          const formData: any = new FormData();
          formData.append('product_category', requestData.category);
          formData.append('product_model', requestData.model);
          formData.append('file_type', requestData.type);
          this.uploadedFiles.forEach((file, index) => {
            formData.append('document[]', file, file.name);
          });
          this.documentService.uploadDocument(formData).subscribe((response: any) => {
            let responseData = response.body;
            if (responseData.responseCode == 200) {
              this.isLoading = new BehaviorSubject<boolean>(false);
              this.toastr.success('The document uploaded successfully')
              this.back()
            } else {
              this.isLoading = new BehaviorSubject<boolean>(false);
              this.toastr.error(responseData.responseMessage)
            }
          }, (err) => {
            this.isLoading = new BehaviorSubject<boolean>(false);
            this.toastr.error(err)
          });
        } else {
          this.toastr.error('No files selected!')
        }
      }
    }
  }

  singleFile: File | any = null;
  onFileChange(event: any) {
    const maxSizeInMB = 10; // Max file size in MB
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024; // Convert MB to bytes

    if (event.target.files.length > 0) {
      const newFiles: any = Array.from(event.target.files);
      for (const file of newFiles) {
        if (file.size > maxSizeInBytes) {
          this.toastr.error(`File ${file.name} exceeds the 10 MB limit.`);
        } else {
          this.uploadedFiles.push(file);
        }
      }
    }
  }

  removeFile(index: number) {
    this.uploadedFiles.splice(index, 1);
  }

  clearForm() {
    this.submitted = false;
    this.uploadedFiles = [];
    this.singleFile = null;
    this.isLink = false;
    this.isDocument = false;
    this.linkName = '';
    this.documentUploadForm.patchValue({
      model: '',
      category: '',
      type: '',
      link: ''
    });
  }

  onCategoryChange(id?: any) {
    this.modelList = [];
    this.variantList = [];
    this.documentUploadForm.patchValue({
      model: '',
    });
    this.modelList = this.modelListAll.filter((x: any) => x.category_id == this.documentUploadForm.value.category ? this.documentUploadForm.value.category : id);
  }

  onModelChange() {
    this.variantList = [];
    this.documentUploadForm.patchValue({
      variant: '',
    });
    this.variantList = this.variantListAll.filter((x: any) => x.model_id == this.documentUploadForm.value.model);
  }

  fullList:any = []
  getList() {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.documentService.getDocument({}).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.fullList = [...responseData.data];
        this.ELEMENT_DATA = responseData.data
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  formatFileSize(sizeInBytes: number): string {
    const sizeInKB = sizeInBytes / 1024;
    const sizeInMB = sizeInKB / 1024;

    if (sizeInMB >= 1) {
      return `${sizeInMB.toFixed(2)} MB`;
    } else {
      return `${sizeInKB.toFixed(2)} KB`;
    }
  }

  isLink: boolean = false;
  isDocument: boolean = false;
  onTypeChange() {
    let type = this.fileTypes.filter((item: any) => item.id == this.documentUploadForm.value.type)
    if (type.length > 0) {
      if (type[0].is_document == 1) {
        this.isLink = false;
        this.isDocument = true;
        this.documentUploadForm.controls['link'].disable()
      } else {
        this.isLink = true;
        this.isDocument = false;
        this.documentUploadForm.controls['link'].enable()
      }
      this.documentUploadForm.patchValue({
        link: ''
      })
      this.linkName = '';
    }
  }

  changeStatus(event: any, object: any) {
       let request: any = {
      id: object.id,
      status: event.checked ? 1 : 0
    }
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.documentService.documentStatus(request).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.success('Document status updated successfully!');
        this.getList();
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error('Document status update failed!')
      }
    }, (err) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }


  updateStatus(event: any, object: any) {
    console.log("changeStatus:", event.checked,event, object)
    let request: any = {
      id: object.id,
      status: event.checked ? 1 : 0
    }
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.documentService.updatedocumentStatus(request).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.success('Document status updated successfully!');
        this.getList();
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error('Document status update failed!')
      }
    }, (err) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  
  public searchInput = new FormControl("");
  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';

    // Filter the user list based on search input
   this.dataSource.data = this.fullList.filter((user: any) => {
  const modelName = user.product_model ? user.product_model.toLowerCase() : '';
  const modelCode = user.product_model_code ? user.product_model_code.toLowerCase() : '';
  const category = user.product_category ? user.product_category.toLowerCase() : '';

  return (
    modelName.includes(filterValue) ||
    modelCode.includes(filterValue) ||
    category.includes(filterValue)
  );
});


    // Reset paginator to the first page
    this.paginator.pageIndex = 0;
    this.dataSource.paginator = this.paginator;
  }

    clearSearch() {
    this.searchInput.setValue(''); // Clear the search input
    this.applyFilter(); // Apply the filter to reset the list
  }
}